import React, { ReactNode } from 'react';
import { AntTooltip } from '../common/AntTooltip';
import { Vital } from '../../api/fetchPastVitalsByPtOid';
import AudioPlayer from 'react-h5-audio-player';
import { TooltipPlacement } from 'antd/lib/tooltip';
import { LAB_VITAL_LOW_HIGH_ABNORMAL_INTERPRETATION } from '../../labTestsConstants';

export const MrPdf: React.FC = () => {
    const currentUrl = window.location.href;
    const parsedUrl = new URL(currentUrl);

    const urlValue = parsedUrl.searchParams.get('urlValue');
    const fileType = parsedUrl.searchParams.get('fileType');

    return urlValue ? (
        fileType === 'IMG' ? (
            <div className="h-full w-full overflow-auto">
                <img
                    key={urlValue}
                    id="rotate-img"
                    style={{ transformOrigin: 'top left' }}
                    className="transform-gpu relative block ease-in-out duration-200 rotate-0 w-full"
                    src={urlValue}
                ></img>
            </div>
        ) : fileType === 'PDF' ? (
            <iframe
                className="h-full w-full"
                src={`/pdfjs-3/web/viewer.html?file=${encodeURIComponent(urlValue)}`}
            />
        ) : fileType === 'VID' ? (
            <video src={urlValue} controls />
        ) : fileType === 'AUD' ? (
            <div className="h-full flex items-center w-full">
                <AudioPlayer autoPlay src={urlValue} onPlay={(e) => console.log('onPlay')} />
            </div>
        ) : null
    ) : null;
};

export const InterpretationTooltip: React.FC<{
    eleId?: string;
    vital: Vital;
    placement?: TooltipPlacement;
}> = ({ eleId, vital, placement = 'right' }) => {
    const { result = '' } = vital || {};
    if (!result) return null;
    const { message, icon } = LAB_VITAL_LOW_HIGH_ABNORMAL_INTERPRETATION[result] || {};

    return icon ? (
        <AntTooltip
            content={message}
            getPopupContainer={() => (eleId && document.getElementById(eleId)) || document.body}
            placement={placement}
        >
            {icon}
        </AntTooltip>
    ) : null;
};

export const RangeTooltip: React.FC<{
    eleId?: string;
    vital: Vital;
    children: ReactNode;
    placement?: TooltipPlacement;
}> = ({ eleId, vital, children, placement = 'right' }) => {
    const { display_text = '' } = vital?.range || {};
    const { aUnit } = vital?.value || {};

    return (
        <AntTooltip
            content={
                <div className="flex items-start space-x-8">
                    <svg
                        className="w-14 h-14 fill-white relative top-3"
                        viewBox="0 0 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625ZM5.98438 9.15625C5.62891 9.15625 5.375 9.43555 5.375 9.76562C5.375 10.1211 5.62891 10.375 5.98438 10.375H8.01562C8.3457 10.375 8.625 10.1211 8.625 9.76562C8.625 9.43555 8.3457 9.15625 8.01562 9.15625H7.8125V6.92188C7.8125 6.5918 7.5332 6.3125 7.20312 6.3125H5.98438C5.62891 6.3125 5.375 6.5918 5.375 6.92188C5.375 7.27734 5.62891 7.53125 5.98438 7.53125H6.59375V9.15625H5.98438ZM7 3.875C6.54297 3.875 6.1875 4.25586 6.1875 4.6875C6.1875 5.14453 6.54297 5.5 7 5.5C7.43164 5.5 7.8125 5.14453 7.8125 4.6875C7.8125 4.25586 7.43164 3.875 7 3.875Z" />
                    </svg>
                    <div>
                        <p>Reference Range</p>
                        <p>
                            {display_text || '-'} {aUnit}
                        </p>
                    </div>
                </div>
            }
            getPopupContainer={() => (eleId && document.getElementById(eleId)) || document.body}
            placement={placement}
        >
            {children}
        </AntTooltip>
    );
};
